import { render } from "./WarningRuleDetail.vue?vue&type=template&id=f491f39c&scoped=true"
import script from "./WarningRuleDetail.vue?vue&type=script&lang=js"
export * from "./WarningRuleDetail.vue?vue&type=script&lang=js"

import "./WarningRuleDetail.vue?vue&type=style&index=0&id=f491f39c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f491f39c"]])

export default __exports__